import '../../scss/common/index.scss';

export default {
  install() {
  }
};
